<template>
  <div class="banner">
    <section class="banner-content">
      <Heading
        class="banner-content__subtitle"
        level="2"
        font-color="#EE396C"
        line-height="50px"
        font-size="36px"
      >
        {{ subtitle }}
      </Heading>
      <Heading
        class="banner-content__name"
        level="1"
        font-color="#ffffff"
        line-height="80px"
        font-size="56px"
      >
        {{ artistCall }}
      </Heading>

      <Button
        color="#ffffff"
        background-color="#EE396C"
        height="52px"
        font-size="17px"
        padding="15px 40px"
      >
        Ver Obras e Realizar Lance
      </Button>
    </section>
    <v-img
      class="banner-content__img"
      :src="mainBannerBG"
    ></v-img>
  </div>
</template>

<script>
import Button from '@/components/Button/Button.vue';
import Heading from '@/components/Heading/Heading.vue';

export default {
  name: 'MainBanner',
  components: {
    Button,
    Heading,
  },
  data() {
    return {
      mainBannerBG: require('../../assets/mainbanner-background.png'),
      subtitle: 'Leilão até 20 de Março',
      artistCall: 'Ciclo: Monica Piloni',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.banner {
  width: 100%;
  height: 960px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: $md) {
    height: 100vh;
  }

  &-content {
    background-color: #292667;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 45px;
    height: 100%;
    min-width: 650px;

    @media (max-width: $xxl) {
      min-width: 100%;
    }

    &__subtitle {
      @media (max-width: $md) {
        font-size: 16px !important;
        line-height: 30px !important;
      }
    }

    &__name {
      margin-top: 10px;
      margin-bottom: 30px;
      text-align: center;
      @media (max-width: $md) {
        font-size: 26px !important;
        line-height: 40px !important;
      }
    }

    &__img {
      height: 100%;
      flex: 1;
    }
  }
}
</style>
